import React, {useEffect, useRef, useState} from 'react';
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {Button} from "primereact/button";
import {TablaAsociadoDeduccion} from "../AsociadoDeduccion/components/TablaAsociadoDeduccion";
import {ModalNuevoAsociadoDeduccion} from "../AsociadoDeduccion/components/ModalNuevoAsociadoDeduccion";
import {ModalEditarAsociadoDeduccion} from "../AsociadoDeduccion/components/ModalEditarAsociadoDeduccion";
import {UsePermissions} from "../../hooks/usePermissions";
import {TablaAsociadoContrato} from "./components/TablaAsociadoContrato";
import {Navigate} from "react-router";
import {TablaPensionado} from "../pensionado/components/TablaPensionado";
import {ModalNuevoAsociadoContrato} from "./components/ModalNuevoAsociadoContrato";
import {ModalEditarPensionado} from "../pensionado/components/ModalEditarPensionado";
import {ModalEditarAsociadoContrato} from "./components/ModalEditarAsociadoContrato";

export const AsociadoContratoPage = () => {

    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }

    return(
        <div className="container-relative">
            {permisos.consultar
                ?
                <TablaAsociadoContrato reload={reload} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}/>
                :
                <Navigate to="/home"/>
            }
            <ModalNuevoAsociadoContrato show={displayNewModal} hide={onHide} />
            <ModalEditarAsociadoContrato show={displayeditModal} hide={onHideEdit} fields={fieldEdit}/>
        </div>
    )
}
